/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import { withStyles } from '@material-ui/core/styles';

// Helpers
import { isEmpty } from '../../../utils/object';

const thirdPartyTypeName = {
    VC: 'VISA CHECKOUT',
    MP: 'MASTER PASS',
    CP: 'CHASE PAY',
    AM: 'AMEX Express',
    AP: 'Apple Pay',
};

const styles = () => ({
    klarnaImg: {
        maxWidth: '56px',
        marginTop: '10px',
    },
});
const PaymentMethod = ({ data: { cardType, cardNumber, thirdPartyType, giftCardPayments, paymentMethod, promotionCode }, isKlarnaLabelEnabled, classes }) => {
      const klarnaImg = 'https://images.contentstack.io/v3/assets/blt95e0138311135214/bltb111c8af26035afa/61280b655e232866ad76bab8/klarna.png';

      let paymentType = 'Credit Card';
      const giftCardNumber = giftCardPayments?.giftCardPaymet?.[0]?.giftCardNumber || '';
      if (thirdPartyType !== '') {
         if (thirdPartyType === 'K4' && paymentMethod !== '') {
               paymentType = paymentMethod;
         } else {
               paymentType = thirdPartyTypeName[thirdPartyType] || thirdPartyType;
         }
      } else if (paymentMethod !== '' && giftCardNumber === '') {
         paymentType = paymentMethod;
      } else if (cardType !== '') {
         paymentType = cardType;
      } else if (cardNumber !== '') {
         paymentType = 'Credit Card';
      } else if (isEmpty(giftCardPayments)) {
         paymentType = 'Paypal';
      } else {
         paymentType = 'Gift Card';
      }

      const renderPaymentMethod = () => {
         if (thirdPartyType === 'K4' && isKlarnaLabelEnabled) {
           return <img src={klarnaImg} alt="klarnaImage" className={classes.klarnaImg} />;
         }
         if (cardNumber) {
           return (
            <>
               <div className="margin-top">
                  Card: <span className="normal body-color">{paymentType}</span>
               </div>
               <div>
                  Last Four Digits: <span className="normal body-color">{cardNumber.replace(/\*/g, '')}</span>
               </div>
            </>
           );
         }
         return null;
      };       

      return (
         <>
            <h2 className="gray-color">
               Payment Information
            </h2>
            <div>Payment Method:</div>
            {renderPaymentMethod()}
            {
               giftCardPayments?.giftCardPaymet.map((cardPayment) => {
                  return (
                  <>
                     <div className='margin-top'>Gift Card:</div>
                     <div>
                        Last Four Digits: <span className="normal body-color">{cardPayment?.giftCardNumber?.replace(/\*/g, '')}</span>
                     </div>
                  </>
                  );
               })
            }
            {promotionCode && <div className='margin-top'>
               Promo: <span className="normal body-color">{promotionCode}</span>
            </div>}
         </>
      );
}

PaymentMethod.propTypes = {
    data: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    isKlarnaLabelEnabled: PropTypes.bool.isRequired,
};

export default withStyles(styles)(PaymentMethod);
